// Delegated open/close handlers
document.addEventListener("click", (e) => {
    const sidebar = document.querySelector('.page-sidebar');
    if (!sidebar) return;
    // OPEN: click on Filter button (or any child)
    if (e.target.closest('.filtersbtn-item')) {
        sidebar.classList.add('show');
        document.body.classList.add('show-sidebar');
        return;
    }
    // CLOSE: click on close button or overlay inside the sidebar
    if (e.target.closest('.page-sidebar .halo-sidebar-close, .page-sidebar .background-overlay')) {
        sidebar.classList.remove('show');
        document.body.classList.remove('show-sidebar');
    }
});
// Optional keyboard support for the Filter button
document.addEventListener("keydown", (e) => {
    if ((e.key === "Enter" || e.key === " ") && e.target.closest('.filtersbtn-item')) {
        const sidebar = document.querySelector('.page-sidebar');
        if (sidebar) {
        sidebar.classList.add('show');
        document.body.classList.remove('show-sidebar');
        }
        e.preventDefault();
    }
});





// Delegated open/close handlers
document.addEventListener("click", (e) => {
    //const sidebar = document.querySelector('.page-sidebar');
    //if (!sidebar) return;
    // OPEN: click on Filter button (or any child)
    if (e.target.closest('.template-collection .toolbar .fix-filter-wrapper .toolbar-item.toolbar-sort .label-tab.label-tab')) {
        //sidebar.classList.add('show');
        document.body.classList.add('toolbar-modal-open');
        return;
    }
    // CLOSE: click on close button or overlay inside the sidebar
    if (e.target.closest('.toolbar .dropdown-menu-header .icon-wrapper, .background-overlay')) {
        //sidebar.classList.remove('show');
        document.body.classList.remove('toolbar-modal-open');
    }
});







    
/**/
// ---- Robust, delegated click + keyboard handler ----
function handlePlusAtcTrigger(btn) {
    // Find a sensible root around the card / product
    const root =
    btn.closest(".product-item") ||
    btn.closest(".card") ||
    btn.closest("[data-product], .grid__item, .product");

    if (!root) return;

    // Prefer a quickshop or add-to-cart trigger within the same card/root
    const realAtcButton =
    root.querySelector('[data-quickshop-popup], [data-btn-addtocart]') ||
    // fallback: try within the whole document for this card (least preferred)
    document.querySelector('[data-quickshop-popup], [data-btn-addtocart]');

    if (realAtcButton) {
        realAtcButton.click();
    }

    const card = root.querySelector(".card") || btn.closest(".card");
    if (card) card.classList.add("quickshop-popup-show");

    if (window.innerWidth <= 767) {
        document.documentElement.classList.add("quick_shop_popup_mobile");
    }
}

document.addEventListener("click", (e) => {
    const plusBtn = e.target.closest(".CP-plusAtc-btn");
    if (plusBtn) {
        e.preventDefault();
        handlePlusAtcTrigger(plusBtn);
        return;
    }
    // Close/cleanup on overlay/close targets
    if (  e.target.closest(".background-overlay, #halo-card-mobile-popup .mobile-popup-header .close-modal, #halo-cart-sidebar .halo-sidebar-close, #halo-card-mobile-popup button.button.cancel-btn")  ) {
        document.documentElement.classList.remove("quick_shop_popup_mobile");
    }
});

// Optional: keyboard support for accessibility (Enter/Space)
document.addEventListener("keydown", (e) => {
    if (  (e.key === "Enter" || e.key === " ") && e.target.closest(".CP-plusAtc-btn")  ) {
        e.preventDefault();
        handlePlusAtcTrigger(e.target.closest(".CP-plusAtc-btn"));
    }
});








